export const volumes = [
  {
    number: 'I',
    color: '#2563EB',
    icon: 'book',
    title: 'The Critical Care Nursing Foundations Guide',
    tagline: 'Build a structured foundation before moving into specialized topics.',
    intro:
      'I designed this volume to help you organize the essential concepts involved in critical care nursing. Rather than reviewing isolated definitions, you’ll find a structured educational reference covering terminology, assessment fundamentals, monitoring concepts, and clinical documentation.',
    inside: [
      'Essential critical care nursing terminology.',
      'Fundamentals of patient assessment.',
      'Cardiovascular assessment concepts.',
      'Respiratory assessment fundamentals.',
      'Introduction to neurological assessment.',
      'Basic physiological monitoring concepts.',
      'Introduction to laboratory monitoring.',
      'Understanding trends versus isolated measurements.',
      'Patient observation and documentation principles.',
      'Educational knowledge checks and review exercises.',
    ],
    takeaway:
      'A structured educational foundation for reviewing essential critical care nursing concepts and organizing your further study.',
    note: '',
  },
  {
    number: 'II',
    color: '#DC2626',
    icon: 'activity',
    title: 'The Hemodynamic Monitoring Reference Atlas',
    tagline: 'Understand the concepts behind cardiovascular monitoring.',
    intro:
      'Hemodynamic monitoring involves several related parameters, and studying them individually can make it difficult to understand their broader physiological context. In this volume, I bring selected concepts together in an organized educational reference.',
    inside: [
      'Fundamentals of hemodynamic monitoring.',
      'Heart rate and blood pressure concepts.',
      'Mean arterial pressure: definitions and interpretation considerations.',
      'Cardiac output and cardiac index fundamentals.',
      'Preload, afterload, and contractility.',
      'Central venous pressure: concepts and limitations.',
      'Introduction to selected advanced monitoring parameters.',
      'Factors that influence hemodynamic measurements.',
      'Understanding trends and measurement variability.',
      'Educational hemodynamic interpretation exercises.',
    ],
    takeaway:
      'A structured reference for studying hemodynamic parameters, understanding their physiological context, and recognizing why individual measurements should not be interpreted in isolation.',
    note: '',
  },
  {
    number: 'III',
    color: '#0D9488',
    icon: 'lungs',
    title: 'The Respiratory Assessment & Ventilation Fundamentals Guide',
    tagline: 'Organize your study of oxygenation, ventilation, and respiratory monitoring.',
    intro:
      'Respiratory assessment involves multiple concepts that are easier to study when their relationships are clearly organized. This volume brings together selected respiratory assessment and ventilation fundamentals.',
    inside: [
      'Respiratory rate and breathing-pattern terminology.',
      'Oxygen saturation and its interpretation limitations.',
      'Oxygenation versus ventilation.',
      'Fundamentals of arterial blood gas analysis.',
      'Introduction to acid-base concepts.',
      'Respiratory assessment reference tables.',
      'Mechanical ventilation terminology.',
      'Overview of common ventilator parameters.',
      'Introduction to respiratory waveforms.',
      'Educational respiratory assessment scenarios.',
    ],
    takeaway:
      'A visual educational reference for reviewing respiratory assessment, oxygenation, ventilation, and selected mechanical ventilation concepts.',
    note: '',
  },
  {
    number: 'IV',
    color: '#7C3AED',
    icon: 'brain',
    title: 'The Neurological & Cardiovascular Assessment Blueprint',
    tagline: 'Bring two essential areas of critical care assessment into one organized reference.',
    intro:
      'I created this volume to help you review neurological and cardiovascular assessment concepts using consistent educational summaries and structured reference tables.',
    inside: [
      'Fundamentals of neurological assessment.',
      'Glasgow Coma Scale components and scoring principles.',
      'Pupillary assessment terminology.',
      'Changes in level of consciousness.',
      'Cardiovascular assessment fundamentals.',
      'Peripheral perfusion assessment concepts.',
      'Introduction to electrocardiography terminology.',
      'Overview of common ECG rhythm characteristics.',
      'Recognition of assessment changes requiring prompt escalation.',
      'Educational scenarios involving multiple assessment findings.',
    ],
    takeaway:
      'An organized reference for studying selected neurological and cardiovascular assessment concepts and understanding their place within a broader clinical evaluation.',
    note: '',
  },
  {
    number: 'V',
    color: '#EA580C',
    icon: 'flask',
    title: 'The Critical Care Monitoring & Laboratory Reference',
    tagline: 'Organize essential monitoring and laboratory concepts in one place.',
    intro:
      'Laboratory results and monitoring parameters provide information, but understanding them requires attention to context, limitations, and changes over time. This volume brings selected concepts together in structured educational tables.',
    inside: [
      'Complete blood count terminology.',
      'Electrolyte concepts and reference tables.',
      'Renal function markers.',
      'Glucose monitoring fundamentals.',
      'Lactate: physiological context and limitations.',
      'Arterial blood gas terminology.',
      'Laboratory trends and variability.',
      'Factors that can influence measurements.',
      'Understanding reference ranges and their limitations.',
      'Educational laboratory interpretation exercises.',
    ],
    takeaway:
      'A structured educational reference for reviewing laboratory and monitoring concepts without treating individual results as definitive conclusions.',
    note: '',
  },
  {
    number: 'VI',
    color: '#DB2777',
    icon: 'list',
    title: 'The Critical Care Clinical Casebook',
    tagline: 'Move beyond memorizing concepts and practice organizing clinical information.',
    intro:
      'One of the most valuable ways to study complex topics is to practice applying what you’ve learned to educational scenarios. That’s why I included a dedicated casebook that brings together concepts from the other five volumes.',
    inside: [
      'Cardiovascular monitoring case scenarios.',
      'Respiratory assessment exercises.',
      'Neurological assessment scenarios.',
      'Laboratory interpretation cases.',
      'Cases involving multiple monitoring findings.',
      'Examples featuring incomplete information.',
      'Questions about measurement limitations.',
      'Clinical documentation exercises.',
      'Guided clinical reasoning worksheets.',
      'Suggested educational explanations and self-assessment questions.',
    ],
    takeaway:
      'An opportunity to practice organizing information, considering alternative explanations, and explaining your reasoning through simulated educational cases.',
    note: 'These scenarios are educational exercises, not validated clinical decision algorithms or substitutes for supervised clinical practice.',
  },
];
